import { ActionFlag } from '@makyoapp/makyo-common'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { hasActionFlag } from '@/shared/builder-utils'

import DialogPanelEdit from './components/DialogPanel/DialogPanelEdit'
import DialogPanelNormal from './components/DialogPanel/DialogPanelNormal'

/**
 * builder leading-sidebar dialog panel
 */
export function DialogPanel() {
  const { dialogAction } = useAppBuilderContext()

  return (
    <div className='dialog-panel mk-builder-panel'>
      {dialogAction && hasActionFlag(dialogAction.flag, ActionFlag.Edit) ? (
        <DialogPanelEdit dialog={dialogAction.dialog} />
      ) : (
        <DialogPanelNormal />
      )}
    </div>
  )
}
